import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './App.scss';
import 'inter-ui/inter.css';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './core/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import { EnvWrapper } from './EnvWrapper';
import { AuthGate } from './auth/AuthGate';
import App from './App';

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <EnvWrapper>
                <AuthGate>
                    <App/>
                </AuthGate>
            </EnvWrapper>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
